import { ExpenseCategory, IncomeCategory, PaymentMethod, Transaction } from "../../../types";


export const dummyIncomeCategories: IncomeCategory[] = [
  { id: '1', name: 'School Fees', type: 'school', transactionType: 'service' },
  { id: '2', name: 'Books', type: 'school', transactionType: 'item' },
  { id: '3', name: 'Uniform', type: 'school', transactionType: 'item' },
  { id: '4', name: 'Rental', type: 'extra', transactionType: 'service' },
  { id: '5', name: 'Donations', type: 'extra', transactionType: 'service' },
];

export const dummyExpenseCategories: ExpenseCategory[] = [
  { id: '1', name: 'Salaries', type: 'school', transactionType: 'service' },
  { id: '2', name: 'Utilities', type: 'school', transactionType: 'service' },
  { id: '3', name: 'Maintenance', type: 'extra', transactionType: 'service' },
  { id: '4', name: 'Supplies', type: 'school', transactionType: 'item' },
];

export const dummyPaymentMethods: PaymentMethod[] = [
  { id: '1', name: 'Cash' },
  { id: '2', name: 'Bank Transfer' },
  { id: '3', name: 'Card' },
];

export const dummyTransactions: Transaction[] = [
  {
    id: '1',
    type: 'income',
    category: 'School Fees',
    amount: 50000,
    date: '2024-03-01',
    description: 'Term 1 School Fees',
    paymentMethod: 'Bank Transfer',
    transactionType: 'service',
  },
  {
    id: '2',
    type: 'expense',
    category: 'Salaries',
    amount: 30000,
    date: '2024-03-02',
    description: 'Staff Salaries March',
    paymentMethod: 'Bank Transfer',
    transactionType: 'service',
  },
];